export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8747.fcee6ae4.jpg";